<script setup lang="ts">
import type { Component } from 'vue';
import { ref, markRaw } from 'vue';
import {
  ProductMenuIcon1,
  ProductMenuIcon2,
  ProductMenuIcon3,
  ProductMenuIcon4,
  ProductMenuIcon5,
  ProductMenuIcon6,
  ChevronDown,
} from '@xpos/icons-svg';

const $props = defineProps<{
  modelValue?: string;
}>();
const $emit = defineEmits(['change', 'update:value', 'update:modelValue']);

const icons: { [key: string]: Component } = {
  '1': markRaw(ProductMenuIcon1),
  '2': markRaw(ProductMenuIcon2),
  '3': markRaw(ProductMenuIcon3),
  '4': markRaw(ProductMenuIcon4),
  '5': markRaw(ProductMenuIcon5),
  '6': markRaw(ProductMenuIcon6),
};

// @ts-ignore
const icon = ref<Component>($props.modelValue ? icons[$props.modelValue] : markRaw(ProductMenuIcon1));

const handleCommand = (key: string) => {
  if (document.activeElement instanceof HTMLElement) document.activeElement.blur();
  icon.value = icons[key];
  $emit('change', key);
  $emit('update:value', key);
  $emit('update:modelValue', key);
};
</script>

<template>
  <el-dropdown :teleported="true" @command="handleCommand" trigger="click" class="w-full">
    <div
      class="flex justify-between items-center bg-white h-[48px] border border-[#a8a8a8] w-full p-[10px] rounded-[10px]"
    >
      <el-icon size="30" color="#3A3A3A"><component :is="icon" /></el-icon>
      <el-icon size="20"><ChevronDown /></el-icon>
    </div>
    <template #dropdown>
      <el-dropdown-menu style="width: 420px">
        <el-dropdown-item command="1">
          <div class="w-[100px] pl-[20px] text-left">
            <el-icon size="20">
              <ProductMenuIcon1 />
            </el-icon>
          </div>
        </el-dropdown-item>
        <el-dropdown-item command="2">
          <div class="w-[100px] pl-[20px] text-left">
            <el-icon size="20">
              <ProductMenuIcon2 />
            </el-icon>
          </div>
        </el-dropdown-item>
        <el-dropdown-item command="3">
          <div class="w-[100px] pl-[20px] text-left">
            <el-icon size="20">
              <ProductMenuIcon3 />
            </el-icon>
          </div>
        </el-dropdown-item>
        <el-dropdown-item command="4">
          <div class="w-[100px] pl-[20px] text-left">
            <el-icon size="20">
              <ProductMenuIcon4 />
            </el-icon>
          </div>
        </el-dropdown-item>
        <el-dropdown-item command="5">
          <div class="w-[100px] pl-[20px] text-left">
            <el-icon size="20">
              <ProductMenuIcon5 />
            </el-icon>
          </div>
        </el-dropdown-item>
        <el-dropdown-item command="6">
          <div class="w-[100px] pl-[20px] text-left">
            <el-icon size="20">
              <ProductMenuIcon6 />
            </el-icon>
          </div>
        </el-dropdown-item>
      </el-dropdown-menu>
    </template>
  </el-dropdown>
</template>
